import { assertValidVersion } from "@tsparticles/engine";
import { OpacityUpdater } from "./OpacityUpdater.js";
export async function loadOpacityUpdater(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addParticleUpdater("opacity", container => {
        return Promise.resolve(new OpacityUpdater(container));
    }, refresh);
}
